"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const find_1 = tslib_1.__importDefault(require("lodash/find"));
function getUnitSetting(command, unitId) {
    const { unitSettings } = command;
    const unitSetting = find_1.default(unitSettings, (setting) => setting.unitId === unitId);
    return unitSetting;
}
exports.default = getUnitSetting;
//# sourceMappingURL=getUnitSetting.js.map